<template>
  <div class="product-container">
    <Bread metertype="智慧燃气"></Bread>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scope>
</style>
